import styled, { css } from 'styled-components';

import { styledReset } from '@pkg/primitives';

export const Wrapper = styled.button<{ $selected: boolean }>`
    ${styledReset.button}

    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 5px;

    border-radius: 6px;
    width: 100%;
    text-align: left;

    transition:
        box-shadow 200ms ease,
        background 200ms ease,
        color 200ms ease;

    &:hover {
        background-color: rgba(255, 255, 255, 0.1);
        box-shadow:
            0 0 68px 0 rgba(255, 255, 255, 0.1) inset,
            0 0 0 1px rgba(255, 255, 255, 0.1) inset;
    }

    ${({ $selected }) =>
        $selected &&
        css`
            background-color: #523df1;

            &:hover {
                background-color: #523df1;
            }
        `}
`;

export const ContentGroup = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    flex-grow: 1;
    overflow: hidden;
`;

export const Thumbnail = styled.div<{ $image: string }>`
    width: 30px;
    height: 30px;
    border-radius: 6px;
    background-image: url(${({ $image }) => $image});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    background-color: rgba(255, 255, 255, 0.1);
    flex-shrink: 0;
`;

export const NameGroup = styled.div`
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const Name = styled.div`
    color: #fff;
    font-size: 14px;
    font-weight: 600;
    line-height: 120%;
    letter-spacing: -0.42px;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const AssetCount = styled.div`
    color: #fff;
    font-size: 12px;
    font-weight: 400;
    line-height: 120%;
    letter-spacing: -0.36px;
    text-align: right;
    white-space: nowrap;

    span {
        color: rgba(255, 255, 255, 0.4);
        font-size: 10px;
        font-weight: 600;
        line-height: 120%;
        letter-spacing: -0.3px;
    }
`;
